import { MapaCirurgico } from '@/types/core'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import _ from 'lodash'
import { timeout, getUser } from '@/utils/common'
import { AgendamentoCirurgia, AgendamentoFiltro, Hospital, Situacao, StatusCirurgiaEnum, TemplateMapaCirurgico } from '@/types/_'
import { CentroCirurgico, Medico } from '@/types/interfaces/Solicitacao'
import ComplexidadeEnum from '@/types/enum/ComplexidadeEnum'

@Module({ namespaced: true, name: 'BackofficeMapaCirurgicoStore' })
export default class BackofficeMapaCirurgicoStore extends VuexModule {
  private mapaCirurgico: MapaCirurgico.IMapaCirurgico = new MapaCirurgico.MapaCirurgico()
  private acaoDefault: any = {
    solicitacaoId: '',
    areaMapaCirurgico: '',
    comentario: '',
    confirmacao: null,
  }

  private conveniosDefault: any[] = []
  private medicosDefault: any[] = []

  public modal: any = {
    mapaCirurgico: false,
    exclusao: false,
    anexos: false,
    acoes: false,
  }

  public mapaCirurgicoTableHeaders: any = [
    { text: '', class: 'table-headers-email', align: 'left', value: '', sortable: false },
    { text: 'Cirurgia realizada', class: 'table-headers-email', align: 'left', value: 'statusCirurgia', sortable: false },
    { text: 'Nº da reserva', class: 'table-headers-email', align: 'left', value: 'numeroAgendamento', sortable: false },
    { text: 'Paciente', class: 'table-headers-email', align: 'left', value: 'pacienteNome', sortable: false },
    { text: 'Médico', class: 'table-headers-email', align: 'left', value: 'nomeMedico', sortable: false },
    { text: 'Caráter', class: 'table-headers-email', align: 'left', value: 'carater', sortable: false },
    { text: 'Sala', class: 'table-headers-email', align: 'left', value: 'salaCirurgicaNome', sortable: false },
    { text: 'Horário', class: 'table-headers-email', align: 'left', value: 'dataAgendamento', sortable: false },
    { text: 'Status', class: 'table-headers-email', align: 'left', value: 'situacao', sortable: false },
    { text: '', class: 'table-headers-email', align: 'left', value: '', sortable: false },
  ]

  public preAnestesiaStatus: any[] = [
    { nome: 'Pendente', status: 'Pendente' },
    { nome: 'Apto', status: 'Apto' },
    { nome: 'Apto com atenção', status: 'AptoComAtencao' },
    { nome: 'Não apto', status: 'NaoApto' },
  ]

  public lembreteStatusFiltro: string = ''
  public deFiltro: Date | string | null = null
  public ateFiltro: Date | string | null = null
  public hospitais: Hospital[] = []
  public hospitaisFiltro: string[] = []
  public convenio: string = ''
  public convenios: any[] = [...this.conveniosDefault]
  public medico: string = ''
  public medicos: any[] = [...this.medicosDefault]
  public search: string = ''
  public ordenadoPorId: string = 'DataUltimaInteracaoAsc'
  public medicoId: string = ''
  public paciente: string = ''
  public possuiItemParticular: boolean | null = null
  public pacienteEstaInternado: boolean | null = null
  public statusAreaBateMapa: string[] = []
  public areaBateMapa: string = ''
  public numeroAgendamento: string = ''
  public convenioFiltro: string[] = []
  public medicoFiltro: string[] = []
  public filterOn: boolean = false
  public filterDrawer: boolean = false
  public itensMapaCirurgico: any[] = []
  public itensMapaCirurgicoFiltered: any[] = []
  public anexos: any[] = []
  public acao: any = { ...this.acaoDefault }
  public exclusaoId: string = ''
  public mapaFinalizado: boolean = false
  public novaDataSolicitadaFiltro: boolean = false
  public dataPrevistaFiltro: boolean = false
  public preAnestesiaFiltro: string = ''
  public opmeFiltro: string = ''
  public dataVirtualFiltro: boolean = false
  public origemFiltro: string | null = null
  public caraterFiltro: string | null = null
  public statusPrecificacaoOperadoraFiltro: string | null = null
  public data: string[] = []
  public agendamentosCirurgia: AgendamentoCirurgia[] = []
  public medicosLoad: Medico[] = []
  public cirurgiaRealizada: StatusCirurgiaEnum | null = null
  public complexidade: ComplexidadeEnum[] = []
  public reservaUti: string[] = []
  public statusRoboAutorizacao: string[] = []
  public mapaCirurgicoStatus: string[] = []
  public tiposAcomodacao: string[] = []
  public sexo: string = ''
  public medicoSolicitanteEspecialidade: string = ''
  private paginaDefault: number = 1
  public pagina: number = this.paginaDefault
  private qtdPorPaginaDefault: number = 25
  public totalSolicitacoes: number = 0
  public qtdPorPagina: number = this.qtdPorPaginaDefault
  public situacoesPendenciaAbertaFiltro: string[] = []
  public situacoesPendenciaAberta: Situacao[] = []
  public ordenadoPor: any = [
    { id: 'DataUltimaInteracaoAsc', value: 'Tempo de ação mais antigo' },
    { id: 'DataUltimaInteracaoDesc', value: 'Tempo de ação mais recente' },
    { id: 'DataDoEnvioAsc', value: 'Data de envio mais antigo' },
    { id: 'DataDoEnvioDesc', value: 'Data de envio mais recente' },
    { id: 'AutorizacaoValidadeAsc', value: 'Data de validade mais antiga' },
    { id: 'AutorizacaoValidadeDesc', value: 'Data de validade mais recente' },
    { id: 'ProximasCirurgias', value: 'Próximas cirurgias' },
  ]

  public centrosCirurgico: CentroCirurgico[] = []

  public centroCirurgico: string = ''
  public tipoPeriodo: string = 'DataAgendamento'

  @Mutation
  setMedicoSolicitanteEspecialidade(value: string) {
    this.medicoSolicitanteEspecialidade = value
  }

  @Mutation
  setTipoPeriodo(value: string) {
    this.tipoPeriodo = value
  }

  @Mutation
  setCentroCirurgico(value: any) {
    this.centroCirurgico = value
  }

  @Mutation
  setCentrosCirurgico(value: CentroCirurgico[]) {
    this.centrosCirurgico = value
  }

  @Mutation
  clearCentroCirurgico() {
    this.centroCirurgico = ''
  }

  @Mutation
  setSexo(value: string) {
    this.sexo = value
  }

  @Mutation
  setReservaUti(value: string[]) {
    this.reservaUti = value
  }

  @Mutation
  setStatusRoboAutorizacao(value: string[]) {
    this.statusRoboAutorizacao = value
  }

  @Mutation
  setmapaCirurgicoStatus(value: string[]) {
    this.mapaCirurgicoStatus = value
  }

  @Mutation
  setTiposAcomodacao(value: string[]) {
    this.tiposAcomodacao = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setLembreteStatusFiltro(value: string) {
    this.lembreteStatusFiltro = value
  }

  @Mutation
  setMedicos(value: Medico[]) {
    this.medicos = value
  }

  @Mutation
  setMedico(value: string) {
    this.medico = value
  }

  @Mutation
  removeMedicoFiltro(value: string) {
    const index = this.medicoFiltro.indexOf(value)
    if (index >= 0) this.medicoFiltro.splice(index, 1)
  }

  @Mutation
  setMedicoFiltro(value: string[]) {
    this.medicoFiltro = value
  }

  @Mutation
  filterMapaCirurgicoByMedico(value: string[]) {
    this.itensMapaCirurgicoFiltered = this.itensMapaCirurgico.filter((mapa: any) => {
      if (value.length === 0) return mapa
      return value.includes(mapa.medicoSolicitante.nome)
    })
  }

  @Mutation
  clearMedicos() {
    this.medicos = []
  }

  @Mutation
  clearMedico() {
    this.medico = ''
  }

  @Mutation
  setCirurgiaRealizada(value: StatusCirurgiaEnum | null) {
    this.cirurgiaRealizada = value
  }

  @Mutation
  setComplexidade(value: ComplexidadeEnum[]) {
    this.complexidade = value
  }

  @Mutation
  setOrderBy(orderBy: string) {
    this.ordenadoPorId = orderBy
  }

  @Mutation
  clearAgendamentosCirurgia() {
    this.itensMapaCirurgico = []
    this.itensMapaCirurgicoFiltered = []
  }

  @Mutation
  setDataAgendamentoVirtual(value: boolean) {
    this.dataVirtualFiltro = value
  }

  @Mutation
  setStatusAreaBateMapa(value: string[]) {
    this.statusAreaBateMapa = value
  }

  @Mutation
  setAreaBateMapa(value: string) {
    this.areaBateMapa = value
  }

  @Mutation
  setPossuiItemParticular(value: boolean | null) {
    this.possuiItemParticular = value
  }

  @Mutation
  setPacienteEstaInternado(value: boolean | null) {
    this.pacienteEstaInternado = value
  }

  @Mutation
  setData(value: string) {
    if (this.data.includes(value)) return
    this.data.push(value)
  }

  @Mutation
  removeData(value: string) {
    const index = this.data.indexOf(value)
    if (index >= 0) this.data.splice(index, 1)
  }

  @Mutation
  setDataVirtualFiltro(value: boolean) {
    this.dataVirtualFiltro = value
  }

  @Mutation
  setOrigemFiltro(value: string | null) {
    this.origemFiltro = value
  }

  @Mutation
  setCaraterFiltro(value: string | null) {
    this.caraterFiltro = value
  }

  @Mutation
  removeSituacoesPendenciaAbertaFiltro(value: string) {
    const index = this.situacoesPendenciaAbertaFiltro.indexOf(value)
    if (index >= 0) this.situacoesPendenciaAbertaFiltro.splice(index, 1)
  }

  @Mutation
  removeConvenioFiltro(value: string) {
    const index = this.convenioFiltro.indexOf(value)
    if (index >= 0) this.convenioFiltro.splice(index, 1)
  }

  @Mutation
  removeReservaUti(value: string) {
    const index = this.reservaUti.indexOf(value)
    if (index >= 0) this.reservaUti.splice(index, 1)
  }

  @Mutation
  removeStatusRoboAutorizacao(value: string) {
    const index = this.statusRoboAutorizacao.indexOf(value)
    if (index >= 0) this.statusRoboAutorizacao.splice(index, 1)
  }

  @Mutation
  removeMapaCirurgicoStatus(value: any) {
    const index = this.mapaCirurgicoStatus.indexOf(value)
    if (index >= 0) this.mapaCirurgicoStatus.splice(index, 1)
  }

  @Mutation
  removeComplexidadeStatus(value: any) {
    const index = this.complexidade.indexOf(value)
    if (index >= 0) this.complexidade.splice(index, 1)
  }

  @Mutation
  removeTipoAcomodacao(value: string) {
    const index = this.tiposAcomodacao.indexOf(value)
    if (index >= 0) this.tiposAcomodacao.splice(index, 1)
  }

  @Mutation
  setOpmeFiltro(value: string) {
    this.opmeFiltro = value
  }

  @Mutation
  setPreAnestesiaFiltro(value: string) {
    this.preAnestesiaFiltro = value
  }

  @Mutation
  setStatusPrecificacaoOperadora(value: string | null) {
    this.statusPrecificacaoOperadoraFiltro = value
  }

  @Mutation
  setConvenioFiltro(value: string[]) {
    this.convenioFiltro = value
  }

  @Mutation
  setSituacoesPendenciaAbertaFiltro(value: string[]) {
    this.situacoesPendenciaAbertaFiltro = value
  }

  @Mutation
  setSituacoesPendenciaAberta(value: Situacao[]) {
    this.situacoesPendenciaAberta = value
  }

  @Mutation
  setNovaDataSolicitadaFiltro(value: boolean) {
    this.novaDataSolicitadaFiltro = value
  }

  @Mutation
  setDataPrevistaFiltro(value: boolean) {
    this.dataPrevistaFiltro = value
  }

  @Mutation
  setPaciente(paciente: string) {
    this.paciente = paciente
  }

  @Mutation
  setMedicoId(value: string) {
    this.medicoId = value
  }

  @Mutation
  setNumeroAgendamento(value: string) {
    this.numeroAgendamento = value
  }

  @Mutation
  setOrdenadoPorId(value: string) {
    this.ordenadoPorId = value
  }

  @Mutation
  setFilterDrawer(value: boolean) {
    this.filterDrawer = value
  }

  @Mutation
  setSearch(value: string) {
    this.search = value
  }

  @Mutation
  setShowModalMapaCirurgico(value: boolean) {
    this.modal.mapaCirurgico = value
  }

  @Mutation
  setShowModalExclusao(value: boolean) {
    this.modal.exclusao = value
  }

  @Mutation
  setShowModalAnexos(value: boolean) {
    this.modal.anexos = value
  }

  @Mutation
  setShowModalAcoes(value: boolean) {
    this.modal.acoes = value
  }

  @Mutation
  setDeFiltro(value: Date | string | null) {
    this.deFiltro = value
  }

  @Mutation
  setAteFiltro(value: Date | string | null) {
    this.ateFiltro = value
  }

  @Mutation
  setItensMapaCirurgico(value: any[]) {
    const solicitacoes = value.map((item: any) => {
      // eslint-disable-next-line
      if (!item.statusPrecificacaoOperadora) item.statusPrecificacaoOperadora = null
      // eslint-disable-next-line
      item.statusCirurgia = !!(item.statusCirurgia && item.statusCirurgia.key === 'Realizada')

      return item
    })
    this.itensMapaCirurgico = solicitacoes
    this.itensMapaCirurgicoFiltered = solicitacoes
  }

  @Mutation
  setAnexos(value: any[]) {
    this.anexos = value
  }

  @Mutation
  setConvenio(value: string) {
    this.convenio = value
  }

  @Mutation
  setTotalSolicitacoes(value: number) {
    this.totalSolicitacoes = value
  }

  @Mutation
  clearFiltro() {
    this.ordenadoPorId = 'DataUltimaInteracaoAsc'
    this.paciente = ''
    this.medicoId = ''
    this.numeroAgendamento = ''
    this.convenioFiltro = []
    this.hospitaisFiltro = []
    this.possuiItemParticular = null
    this.pacienteEstaInternado = null
    this.areaBateMapa = ''
    this.statusAreaBateMapa = []
    this.dataVirtualFiltro = false
    this.origemFiltro = null
    this.caraterFiltro = null
    this.medicoFiltro = []
    this.lembreteStatusFiltro = ''
    this.opmeFiltro = ''
    this.reservaUti = []
    this.mapaCirurgicoStatus = []
    this.tiposAcomodacao = []
    this.sexo = ''
    this.centroCirurgico = ''
    this.tipoPeriodo = 'DataAgendamento'
    this.situacoesPendenciaAbertaFiltro = []
    this.medicoSolicitanteEspecialidade = ''
    this.complexidade = []
  }

  @Mutation
  setFilterOn(value: boolean) {
    this.filterOn = value
  }

  @Mutation
  setConvenios(value: any[]) {
    this.convenios = value
  }

  @Mutation
  setHospitais(value: Hospital[]) {
    this.hospitais = value
  }

  @Mutation
  setHospitaisFiltro(value: string[]) {
    this.hospitaisFiltro = value
  }

  @Mutation
  clearHospitaisFiltro() {
    this.hospitaisFiltro = []
  }

  @Mutation
  removeHospitaisFiltro(value: string) {
    const index = this.hospitaisFiltro.indexOf(value)
    if (index >= 0) this.hospitaisFiltro.splice(index, 1)
  }

  @Mutation
  setExclusaoId(value: string) {
    this.exclusaoId = value
  }

  @Mutation
  setAcao(value: any) {
    this.acao = value
  }

  @Mutation
  setMapaFinalizado(value: boolean) {
    this.mapaFinalizado = value
  }

  @Mutation
  removeSolicitacao(id: string) {
    const solicitacao = this.itensMapaCirurgico.find(e => e.id === id)
    this.itensMapaCirurgico.splice(this.itensMapaCirurgico.indexOf(solicitacao), 1)
  }

  @Mutation
  updateSolicitacao({ id, mapaCirurgico }) {
    const solicitacao = this.itensMapaCirurgico.find(e => e.id === id)
    solicitacao.mapaCirurgico = mapaCirurgico
  }

  @Mutation
  setMedicosLoad(medicos: any[]) {
    this.medicosLoad = medicos
  }

  @Mutation
  clearSearch() {
    this.search = ''
  }

  @Mutation
  clearItensMapaCirurgico() {
    this.itensMapaCirurgico = []
    this.itensMapaCirurgicoFiltered = []
  }

  @Mutation
  clearAnexos() {
    this.anexos = []
  }

  @Mutation
  clearConvenios() {
    this.convenios = []
  }

  @Mutation
  clearConvenio() {
    this.convenio = ''
  }

  @Mutation
  clearAcao() {
    this.acao = { ...this.acaoDefault }
  }

  @Mutation
  clearExclusaoId() {
    this.exclusaoId = ''
  }

  @Action({ commit: 'setConvenios' })
  async getAllConvenios() {
    const request = await this.mapaCirurgico.getAllConveniosByUsuarioHospitalLogado()
    if (request.success) return request.data
    return []
  }

  @Action({ commit: 'setMedicos' })
  async loadAMedicos() {
    const user = getUser()
    const usuarioId = user.profile.sub
    const request = await this.mapaCirurgico.getAllMedicoByUsuarioId(usuarioId)
    if (request.success) return request.data
    return []
  }

  @Action
  async putCirurgiaRealizada(params: any) {
    const request = await this.mapaCirurgico.cirurgiaRealizada(params)
    return request
  }

  @Action
  async loadAgendamentosMedicoSearch() {
    const queryString: AgendamentoFiltro = {
      situacao: [],
      statusAvaliacaoPreAnestesiaQuery: [],
      convenioNome: this.convenioFiltro,
      hospitalId: this.hospitaisFiltro,
      dataAgendamentoVirtual: this.dataVirtualFiltro,
      possuiItemParticular: this.possuiItemParticular,
      pacienteEstaInternado: this.pacienteEstaInternado,
      areaBateMapa: this.areaBateMapa,
      statusAreaBateMapa: this.statusAreaBateMapa,
      origemDaSolicitacao: this.origemFiltro,
      carater: this.caraterFiltro,
      statusPrecificacaoOperadora: this.statusPrecificacaoOperadoraFiltro,
      etapa: 'Agendamento',
      medicoId: this.medicoId,
      numeroAgendamento: this.numeroAgendamento,
      opme: this.opmeFiltro,
      orderBy: this.ordenadoPorId,
      paciente: this.paciente,
      pagina: this.pagina,
      preanestesia: this.preAnestesiaFiltro,
      qtdPorPagina: this.qtdPorPagina,
      usuarioId: getUser().profile.sub,
      lembreteStatus: this.lembreteStatusFiltro,
      de: this.deFiltro,
      ate: this.ateFiltro,
      sexo: this.sexo,
      reservaUti: this.reservaUti,
      mapaCirurgicoStatus: this.mapaCirurgicoStatus,
      tiposAcomodacao: this.tiposAcomodacao,
      statusCirurgia: this.cirurgiaRealizada,
      centroCirurgico: this.centroCirurgico,
      especialidadePrincipalDoMedico: this.medicoSolicitanteEspecialidade,
      tipoPeriodo: this.tipoPeriodo,
      situacaoPendenciaAberta: this.situacoesPendenciaAbertaFiltro,
      complexidade: this.complexidade,
    }

    const request = await this.mapaCirurgico.getSolicitacoesMapaCirurgico(queryString)
    if (request.success) {
      this.context.commit('setItensMapaCirurgico', request.data.solicitacoes)
      this.context.commit('setConvenios', request.data.solicitacoes.reduce((c: any, d: any) => {
        if (!c.some((s: any) => s.nome === d.convenioNome)) c.push({ nome: d.convenioNome })
        return c
      }, []))
      this.context.commit('setMedicos', _.map(request.data.solicitacoes, 'medicoSolicitante'))
      this.context.commit('setMapaFinalizado', !!request.data.mapaCirurgicoId)
      this.context.commit('setTotalSolicitacoes', request.data.totalSolicitacoes)
    }
    return []
  }

  @Action
  async finalizarMapa() {
    await timeout(2000)
    const data = {
      solicitacoesId: _.map(this.itensMapaCirurgico, 'id'),
      data: `${this.search.substring(4, 8)}-${this.search.substring(2, 4)}-${this.search.substring(0, 2)}`,
    }
    const request = await this.mapaCirurgico.criarMapaCirurgico(data)
    if (request.success) this.context.commit('setMapaFinalizado', true)

    return request
  }

  @Action
  async removerSolicicitacao({ motivo }) {
    const data = {
      solicitacaoId: this.exclusaoId,
      mensagemDaPendencia: motivo,
    }

    const request = await this.mapaCirurgico.excluirSolicitacaoMapaCirurgico(data)
    if (request.success) this.context.commit('removeSolicitacao', this.exclusaoId)
    return request
  }

  @Action
  async confirmarAcao({ confirmacao, comentario }) {
    const data = {
      solicitacaoId: this.acao.solicitacaoId,
      areaMapaCirurgico: this.acao.areaMapaCirurgico,
      payload: {
        areaMapaCirurgico: this.acao.areaMapaCirurgico,
        comentario,
        confirmacao,
      },
    }

    const request = await this.mapaCirurgico.areaMapaCirurgicoConfirmaSolicitacao(data)
    if (request.success) this.context.commit('updateSolicitacao', { id: this.acao.solicitacaoId, mapaCirurgico: request.data })
    this.context.commit('clearAcao')
    return request
  }

  @Action({ commit: 'setHospitais' })
  async getAllHospitais() {
    const request = await this.mapaCirurgico.getHospitalCurrentUser()
    if (request.success) return request.data
    return []
  }

  @Action
  async getCentroCirurgicoByHospitalId(params: any) {
    const { hospitalIds } = params
    if (hospitalIds && hospitalIds.length <= 0) {
      this.context.commit('setCentrosCirurgico', [])
      this.context.commit('clearCentroCirurgico')
      return null
    }

    const request = await this.mapaCirurgico.getCentroCirurgico(params)
    if (request.success) {
      request.data.map((c) => {
        const temp = c
        temp.nome = `${c.hospital.nome} - ${c.nome}`
        return temp
      })

      this.context.commit('setCentrosCirurgico', request.data)
    }
    return request
  }

  private templateMapaCirurgicoDefault: TemplateMapaCirurgico = {
    agendamento: false,
    autorizacao: false,
    suprimentos: false,
    farmacia: false,
    centroCirurgico: false,
    centralDeMateriaisEspeciais: false,
    engenhariaClinica: false,
    preInternacao: false,
    opme: false,
    hotelaria: false,
    anestesia: false,
    gerenciamentoLeito: false,
    bancoDeSangue: false,
    confirmacaoCirurgiaMedico: false,
    confirmacaoCirurgiaPaciente: false,
    tesouraria: false,
  }

  public templateMapaCirurgico: TemplateMapaCirurgico = { ...this.templateMapaCirurgicoDefault }

  @Mutation
  setTemplateMapaCirurgico(templateMapaCirurgico: TemplateMapaCirurgico) {
    this.templateMapaCirurgico = templateMapaCirurgico
  }

  @Mutation
  clearTemplateMapaCiourgico() {
    this.templateMapaCirurgico = { ...this.templateMapaCirurgicoDefault }
  }

  @Action({ commit: 'setTemplateMapaCirurgico' })
  async getTemplateMapaCirurgico() {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getTemplateMapaCirurgico()
      return request.success ? request.data.templateMapaCirurgico as TemplateMapaCirurgico : { ...this.templateMapaCirurgicoDefault }
    } catch (error) {
      return { ...this.templateMapaCirurgicoDefault }
    }
  }

  @Action
  init() {
    this.context.dispatch('getAllConvenios')
    this.context.dispatch('loadAMedicos')
  }
}
